import { Link } from "react-router-dom";
import React from "react";

const About = () => {
  return (
    <section className="relative w-full py-28 px-[25px] sm:px-16 overflow-hidden">
      {/* 🔷 DARK CLIP-PATH BACKGROUND SHAPE — NOW ON THE LEFT */}
      <div
        className="
          absolute top-0 left-0 w-[760px] h-[760px] -z-10
          bg-gradient-to-br from-[#0f172a] to-[#1e293b]
          opacity-80 shadow-[0_40px_80px_rgba(0,0,0,0.45)]
        "
        style={{
          clipPath:
            "polygon(0% 0%, 32% 0%, 100% 20%, 100% 60%, 32% 100%, 0% 100%)",
        }}
      />

      {/* 📌 CONTENT WRAPPER */}
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-20">
        {/* LEFT — MODERN 3-LOGO FEATURE BLOCK */}
        <div className="w-full lg:w-[52%] flex items-center justify-center relative">
          {/* 🔹 DARK CLIP-PATH BEHIND LOGOS */}
          <div
            className="
              absolute -z-10 w-[500px] h-[500px]
              bg-gradient-to-br from-[#111827] via-[#1e293b] to-[#0f172a]
              opacity-90 shadow-[0_30px_60px_rgba(0,0,0,0.45)]
              rounded-3xl
            "
            style={{
              clipPath:
                "polygon(50% 0%, 88% 12%, 100% 50%, 84% 88%, 50% 100%, 18% 88%, 0% 50%, 14% 14%)",
            }}
          />

          {/* STACKED LOGOS */}
          <div className="flex flex-col items-center gap-10">
            <img
              src="./assets/bmt/scfn_logo.PNG"
              alt="SCFN Logo"
              className="h-24 w-auto object-contain brightness-110"
            />

            <div className="h-[2px] w-40 bg-gray-500/30 rounded-full" />

            <img
              src="./assets/bmt/luth_logo2.PNG"
              alt="LUTH Logo"
              className="h-24 w-auto object-contain brightness-110"
            />

            <div className="h-[2px] w-40 bg-gray-500/30 rounded-full" />

            <img
              src="./assets/bmt/Vanderbilt_University_seal.svg.png"
              alt="VUMC Logo"
              className="h-24 w-auto object-contain brightness-110"
            />
          </div>
        </div>

        {/* RIGHT — TEXT BLOCK */}
        <div className="w-full lg:w-[48%]">
          {/* Subtitle */}
          <p className="uppercase tracking-wider text-primary_red font-semibold mb-3">
            Partnership Overview
          </p>

          {/* Title — updated to visible color */}
          <h2
            className="
              text-[36px] lg:text-[48px] font-[700] leading-[1.15]
              text-gray-900 max-w-xl
            "
          >
            SCFN, LUTH & VUMC —
            <span className="text-primary_red">
              {" "}
              Health Collaboration
            </span>
          </h2>

          {/* Body text — updated to visible color */}
          <p
            className="
              text-[18px] md:text-[20px] text-gray-700 leading-relaxed mt-6 
              max-w-[620px]
            "
          >
            {/* The SCFN/LUTH/VUMC BMT Centre, opened in 2022, represents a major step 
            in providing safe, affordable and world-class care for sickle cell disorder 
            in Nigeria. Beyond treatment, the Centre is designed as a hub for African 
            BMT training and a catalyst for Reverse Medical Tourism — enabling patients 
            to access advanced care right here in Lagos. */}
            The SCFN/LUTH/VUMC BMT Centre was officially opened January 2022 and
            it is heartwarming to know that the SCFN/LUTH/VUMC BMT Centre will
            not only provide safe, quality and affordable cure for sickle cell
            disorder, but also serve as a Centre of Excellence for BMT training
            in Africa. In addition, it will usher a new dawn for Nigeria and the
            concept of Reverse Medical Tourism as Nigeria will be hosting
            patients from other countries travelling in to access SAFE, QUALITY,
            MORE AFFORDABLE BONE MARROW TRANSPLANTATION AT THE SCFN/LUTH/VUMC
            BMT CENTRE, LAGOS.
            <Link to="/about" className="pl-2">
              <span className="font-bold text-primary_red cursor-pointer">
                Learn More
              </span>
            </Link>
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
